module.exports = __webpack_public_path__ + "static/media/MOTIVATION_EXT_NEG.0f96809c.md";